<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn text color="info" class="mx-auto" v-on="on">
        Register
      </v-btn>
    </template>
    <RegisterForm @closed="dialog = false" @registered="$emit('registered')" />
  </v-dialog>
</template>

<script>
import RegisterForm from "./RegisterForm.vue";

export default {
  name: "RegisterPopup",
  components: { RegisterForm },
  data: () => ({
    dialog: false
  })
};
</script>
